import React from 'react'
import { Button } from '@material-ui/core'

import Character from './Character'
import { becomeGM } from '../../api/user'
import { Redirect } from 'react-router-dom'
import CustomModal from '../../components/CustomModal'

const Onboarding = ({ campaignData, campaignId, isOpen, onClose, titleClass }) => {
  const [ showCharacterSheet, setShowCharacterSheet ] = React.useState(false)
  const [ goHome, shouldGoHome ] = React.useState(false)

  const onGM = async () => {
    await becomeGM(campaignId)
    onClose()
  }

  const onModalClose = () => {
    shouldGoHome(true)
    onClose()
  }

  const campaignHasGM = !!campaignData?.GM

  if (goHome) return <Redirect to='/' />

  return (
    <CustomModal isOpen={isOpen} onClose={onModalClose}>
      {!showCharacterSheet ?
        <div css={`margin-top: 8px;`}>
          Welcome to the campaign!
          {campaignHasGM ?
            ' Start by creating your character:'
            :
            ' Start by creating a new character, or becoming the GM:'
          }
          <div css={`margin-top: 16px; display: flex; justify-content: ${campaignHasGM ? 'center' : 'space-around'};`}>
            <Button type='button' variant='contained' color='primary' css={`width: 45%;`} onClick={() => setShowCharacterSheet(true)}>
              New Character
            </Button>
            {!campaignHasGM &&
              <Button type='button' variant='contained' color='secondary' css={`width: 45%;`} onClick={onGM}>
                Become GM
              </Button>
            }
          </div>
        </div>
        :
        <Character titleClass={titleClass} campaignId={campaignId} onCancel={() => setShowCharacterSheet(false)} onSuccess={() => {
          setShowCharacterSheet(false)
          onClose()
        }} isEditing isOnboarding />
      }
    </CustomModal>
  )
}

export default Onboarding
